export default __webpack_public_path__ + "static/media/oscer-pres-altered-bowel-habits.44846dac.svg";